import React from "react";

const CSS = `
@keyframes b24-shine-sweep {
  0% { background-position: 115% 0; }
  100% { background-position: -15% 0; }
}
@keyframes b24-glow-pulse {
  0%, 100% { filter: drop-shadow(0 0 2px rgba(249,176,0,0.25)); }
  50% { filter: drop-shadow(0 0 16px rgba(249,176,0,0.85)); }
}
.b24-shine-dark {
  background: linear-gradient(110deg, #1E293B 0%, #1E293B 42%, #F9B000 50%, #FFD966 53%, #1E293B 60%, #1E293B 100%);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: b24-shine-sweep 2.6s ease-in-out infinite alternate;
}
.b24-shine-red {
  background: linear-gradient(110deg, #E7343F 0%, #E7343F 42%, #FFD966 50%, #FFF3C4 53%, #E7343F 60%, #E7343F 100%);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: b24-shine-sweep 2.6s ease-in-out infinite alternate;
}
.b24-shine-white {
  background: linear-gradient(110deg, #FFFFFF 0%, #FFFFFF 42%, #F9B000 50%, #FFD966 53%, #FFFFFF 60%, #FFFFFF 100%);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: b24-shine-sweep 2.6s ease-in-out infinite alternate;
}
.b24-logo-shine { position: relative; display: inline-block; line-height: 0; }
.b24-logo-shine::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(115deg, transparent 34%, rgba(255,255,255,0.95) 50%, transparent 66%);
  background-size: 300% 100%;
  -webkit-mask-image: url('/logo-icon.png');
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-image: url('/logo-icon.png');
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  animation: b24-shine-sweep 2.6s ease-in-out infinite alternate;
}
.b24-logo-glow { animation: b24-glow-pulse 2.4s ease-in-out infinite; }
`;

function Brand({ logoClass = "", textDark = true, shineText = false }) {
    return (
        <div className="flex items-center gap-3">
            <span className={`b24-demo-logo ${logoClass}`} style={{ display: "inline-block", lineHeight: 0 }}>
                <span className={logoClass.includes("shine") ? "b24-logo-shine" : ""} style={{ display: "inline-block" }}>
                    <img src="/logo-icon.png" alt="logo" className="h-14 w-auto" />
                </span>
            </span>
            <span className="font-heading font-bold tracking-tight text-3xl">
                {shineText ? (
                    <>
                        <span className={textDark ? "b24-shine-dark" : "b24-shine-white"}>Bewerbung24</span>
                        <span className="b24-shine-red">.ai</span>
                    </>
                ) : (
                    <>
                        <span className={textDark ? "text-slate-900" : "text-white"}>Bewerbung24</span>
                        <span className="gradient-text">.ai</span>
                    </>
                )}
            </span>
        </div>
    );
}

function VariantCard({ id, title, desc, children }) {
    return (
        <div className="card-elev overflow-hidden" data-testid={`logo-variant-${id}`}>
            <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-3">
                <span className="h-8 w-8 rounded-full text-white font-bold flex items-center justify-center text-sm" style={{ background: "var(--gradient-primary)" }}>{id}</span>
                <div>
                    <p className="font-heading font-bold text-slate-900">{title}</p>
                    <p className="text-xs text-slate-500">{desc}</p>
                </div>
            </div>
            <div className="grid sm:grid-cols-2">
                <div className="bg-white p-8 flex items-center justify-center">{children[0]}</div>
                <div className="p-8 flex items-center justify-center" style={{ background: "#1E293B" }}>{children[1]}</div>
            </div>
        </div>
    );
}

export default function LogoDemo() {
    return (
        <div className="min-h-screen bg-slate-50 py-10 px-4" data-testid="logo-demo-page">
            <style>{CSS}</style>
            <div className="max-w-3xl mx-auto space-y-6">
                <div>
                    <h1 className="font-heading text-2xl font-bold text-slate-900">Logo-Effekt Vorschau</h1>
                    <p className="text-sm text-slate-500 mt-1">Live-Animation — schau dir die Bewegung an und sag mir, welche Variante (A, B oder C) ich einbauen soll. Links: heller Hintergrund · Rechts: dunkler Hintergrund.</p>
                </div>

                <VariantCard id="A" title="Licht-Sweep" desc="Ein Lichtstreifen wandert über Logo und Schrift hin und her — wie ein vorbeiziehendes Licht.">
                    {[
                        <div key="l" className="flex items-center gap-3">
                            <span className="b24-logo-shine"><img src="/logo-icon.png" alt="" className="h-14 w-auto" /></span>
                            <span className="font-heading font-bold tracking-tight text-3xl">
                                <span className="b24-shine-dark">Bewerbung24</span><span className="b24-shine-red">.ai</span>
                            </span>
                        </div>,
                        <div key="d" className="flex items-center gap-3">
                            <span className="b24-logo-shine"><img src="/logo-icon.png" alt="" className="h-14 w-auto" /></span>
                            <span className="font-heading font-bold tracking-tight text-3xl">
                                <span className="b24-shine-white">Bewerbung24</span><span className="b24-shine-red">.ai</span>
                            </span>
                        </div>,
                    ]}
                </VariantCard>

                <VariantCard id="B" title="Glow-Puls" desc="Das Logo pulsiert sanft mit einem warmen, goldenen Leuchten — Schrift bleibt ruhig.">
                    {[
                        <div key="l" className="flex items-center gap-3">
                            <span className="b24-logo-glow" style={{ display: "inline-block", lineHeight: 0 }}><img src="/logo-icon.png" alt="" className="h-14 w-auto" /></span>
                            <span className="font-heading font-bold tracking-tight text-3xl">
                                <span className="text-slate-900">Bewerbung24</span><span className="gradient-text">.ai</span>
                            </span>
                        </div>,
                        <div key="d" className="flex items-center gap-3">
                            <span className="b24-logo-glow" style={{ display: "inline-block", lineHeight: 0 }}><img src="/logo-icon.png" alt="" className="h-14 w-auto" /></span>
                            <span className="font-heading font-bold tracking-tight text-3xl">
                                <span className="text-white">Bewerbung24</span><span className="gradient-text">.ai</span>
                            </span>
                        </div>,
                    ]}
                </VariantCard>

                <VariantCard id="C" title="Sweep + Glow kombiniert" desc="Lichtstreifen wandert über Logo & Schrift UND das Logo leuchtet dabei sanft auf.">
                    {[
                        <div key="l" className="flex items-center gap-3">
                            <span className="b24-logo-glow" style={{ display: "inline-block", lineHeight: 0 }}>
                                <span className="b24-logo-shine"><img src="/logo-icon.png" alt="" className="h-14 w-auto" /></span>
                            </span>
                            <span className="font-heading font-bold tracking-tight text-3xl">
                                <span className="b24-shine-dark">Bewerbung24</span><span className="b24-shine-red">.ai</span>
                            </span>
                        </div>,
                        <div key="d" className="flex items-center gap-3">
                            <span className="b24-logo-glow" style={{ display: "inline-block", lineHeight: 0 }}>
                                <span className="b24-logo-shine"><img src="/logo-icon.png" alt="" className="h-14 w-auto" /></span>
                            </span>
                            <span className="font-heading font-bold tracking-tight text-3xl">
                                <span className="b24-shine-white">Bewerbung24</span><span className="b24-shine-red">.ai</span>
                            </span>
                        </div>,
                    ]}
                </VariantCard>

                <div className="card-elev p-5 text-sm text-slate-600">
                    <p className="font-bold text-slate-800 mb-1">So geht's weiter:</p>
                    <p>Schreib mir einfach <strong>„Variante A"</strong>, <strong>„B"</strong> oder <strong>„C"</strong> — ich baue den Effekt dann überall ein (Navbar, Login, öffentliche Seiten). Anpassungen an Tempo oder Helligkeit sind jederzeit möglich.</p>
                </div>
            </div>
        </div>
    );
}
